import { Button, makeStyles } from '@material-ui/core';
import React from 'react';
import { appConfig } from '../../../../../configApp';


let responsiveLength = "1000";


let useSyles = makeStyles((theme) => ({
    root: {
        // marginTop: 50,
        ...theme.grid.gridMdContent,
        // maxWidth: '100%',
        margin: 'auto',

        minHeight: 350,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.down('1500')]: {
            width: '90%',
        },
        [theme.breakpoints.down('1250')]: {
            // width: '95%',
        },
        [theme.breakpoints.down(responsiveLength)]: {
            minHeight: 525,
        },
        [theme.breakpoints.down('501')]: {
            width: '97%',
        }
    },
    grid: {
        width: '100%',
        margin: 'auto',
        position: 'relative',
        // color: '#ffffff',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        [theme.breakpoints.down('1135')]: {
            flexDirection: 'column-reverse',
        },
        [theme.breakpoints.down(responsiveLength)]: {
            flexDirection: 'column-reverse',
        }
    },
    gridImages: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.down(responsiveLength)]: {
            width: '100%',
            justifyContent: 'center',
            '& > img': {
                maxWidth: '100%',
                marginBottom: 10
            },
        }
    },
    desce: {
        margin: '20px 0px',
        width: 450,
        fontSize: 18,
        [theme.breakpoints.down('1500')]: {
            fontSize: 16,
        },
        [theme.breakpoints.down('1250')]: {
            fontSize: 14,
        },
        [theme.breakpoints.down('500')]: {
            width: '100%',
            margin: 'auto',
            margin: '20px 0px',
        }
    },
    title: {
        fontSize: 32,
        whiteSpace: 'nowrap',
        fontWeight: 'bold',
        [theme.breakpoints.down('1500')]: {
            fontSize: 26,
        },
        [theme.breakpoints.down('500')]: {
            whiteSpace: 'normal',
            width: '100%',
            margin: 'auto',
            textAlign:'center'
        }
    },
    gridBtn: {
        width: '94%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        [theme.breakpoints.down(responsiveLength)]: {
            justifyContent: 'space-around',
        },
        [theme.breakpoints.down(responsiveLength)]: {
            flexDirection: 'column',
            width: '100%',
            justifyContent: 'center'
        },
        [theme.breakpoints.down(500)]: {
            width: '90%',
            margin: 'auto'
        },
    },
    btnWhite: {
        // width: '40%',
        fontSize: 14,
        backgroundColor: "transparent",
        color: "white",
        margin: "0px 5px",
        padding: '9px 20px',
        border: `1px solid black`,
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        whiteSpace:'nowrap',
        [theme.breakpoints.down("1236")]: {
            padding: '9px 20px',
        },
        '&:hover': {
            backgroundColor: "#ffffff",
            color: "#071b2c !important",
            border: `1px solid balck`,
        },
        [theme.breakpoints.down(responsiveLength)]: {
            width: '100%',
            marginTop: 9,
        },
    },
    btnRed: {
        // width: '58%',
        backgroundColor: theme.palette.light.type2,
        color: "white !important",
        margin: "0px 5px 0px 0px",
        padding: '9px 20px',
        border: `1px solid ${theme.palette.light.type2}`,
        fontSize: 14,
        whiteSpace:'nowrap',
        [theme.breakpoints.down("1236")]: {
            padding: '9px 30px',
        },
        '&:hover': {
            backgroundColor: "transparent",
            color: "#071b2c !important",
            border: `1px solid black `,
        },
        [theme.breakpoints.down(responsiveLength)]: {
            width: '100%',
            margin: 0
        },
    },
    line: {
        borderRadius: 3,
        height: 4,
        border: 'none',
        backgroundColor: theme.palette.light.type2,
        position: 'absolute',
        top: 0,
        width: 30,
        [theme.breakpoints.down('1135')]: {
            top: -10,
            display: 'none'
        },
        [theme.breakpoints.down(responsiveLength)]: {
            top: -10,
            display: 'none'
        }
    },
    gridIconRight: {
        width: 50,
        marginRight: 40,
        [theme.breakpoints.down(responsiveLength)]: {
            marginRight: 0,
            display: 'none',
        }
    },
    gridIconLeft: {
        width: 50,
        marginLeft: 0,
        transform: "rotate(180deg)",
        [theme.breakpoints.down(responsiveLength)]: {
            marginLeft: 0,
            display: 'none',
        }
    },
    icon: {
        width: 50,
    },
    gridContent: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.down(responsiveLength)]: {
            marginRight: 0,
            marginTop: 20,
            textAlign: 'center',
            width: '100%',
            justifyContent: 'center',
        }
    },
    bgBtn: {
        height: 40,
        width: 40,
        padding: 5,
        backgroundColor: '#132b41',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 9,
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: 'rgba(255,255,255,0.2)',
        }
    }
}))

export default function Index({ data }) {

    let classes = useSyles();

    return (
        <div className={classes['root']}>
            <div className={classes['grid']}>
                <div className=''  style={{position:'relative'}}>
                    <div>
                        <div className={classes['line']} />
                        <h3 className={classes['title']}>
                            <span style={{ display: 'inline-block', color: "#DA212E", marginLeft: 10 }}>
                             سهام عدالت
                            </span>
                            <span>
                            متوفیان
                            </span>

                        </h3>
                        <p className={classes['desce']}>
                        سهام عدالت متوفیان بعد از 18 سال زنده شد

                            {/* با قیمت رقابتی در کارگزاری پویانبا قیمت رقابتی در کارگزاری پویانبا قیمت رقابتی در کارگزاری پویان */}
                        </p>
                        <div className={classes['gridBtn']}>
                            <Button
                                className={classes.btnRed} 
                                // href={'https://pouyan.ebgo.ir'}
                                href={appConfig?.baseUrlDeceased}
                                // target={'_blank'}
                            >
                             درخواست انتقال سهام عدالت متوفیان
                     
                            </Button>

                            <Button
                                className={classes.btnWhite} 
                                href={'/deceased'}
                                // href={`tel:${'02153782000'}`}
                            >
                                مشاوره و اطلاعات بیشتر
                                {/* <ArrowBack className='btnArrow' /> */}
                                {/* <img src='/assets/images/slider/arrowLeft.png' alt='' /> */}
                            </Button>

                        </div>
                    </div>
                    <div>

                    </div>
                </div>
                <div className={classes['gridImages']}>
                    <img src={'/assets/images/newImages/Untitled-4.png'} alt={data?.title} />
                </div>
            </div>
        </div >)
}
